export default "__VITE_ASSET__DlXpPrHy__"